import { useEffect, useState } from "react";
import { api, fmtBRL, fmtInt } from "@/lib/api";
import { buildParams } from "./pcShared";
import { Trophy } from "@phosphor-icons/react";

const MEDALS = ["🥇", "🥈", "🥉"];

function RankCard({ title, rows, testid }) {
  return (
    <div className="tile p-3" data-testid={testid}>
      <div className="overline text-[10px] text-zinc-500 mb-2 flex items-center gap-1">
        <Trophy size={12} weight="bold" /> {title}
      </div>
      <div className="space-y-1">
        {rows.length === 0 && <div className="text-xs text-zinc-400">Sem dados no período</div>}
        {rows.map((r, i) => (
          <div key={`${r.label}-${i}`} className="flex items-center gap-2 text-xs">
            <span className="w-6 text-center font-mono">{i < 3 ? MEDALS[i] : i + 1}</span>
            <span className="flex-1 truncate font-medium">{r.label}</span>
            <span className="font-mono font-bold">{r.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function RankingsTab({ applied }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get("/production-reports/rankings", { params: buildParams(applied) }).then(({ data }) => setData(data));
  }, [applied]);

  if (!data) return <div className="tile p-8 text-center text-zinc-400 animate-pulse">Carregando rankings...</div>;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" data-testid="pc-rankings-tab">
      <RankCard title="TOP COLABORADORES · PEÇAS" testid="pc-rank-collab-pieces"
        rows={data.top_collaborators_pieces.map((r) => ({ label: r.name, value: fmtInt(r.pieces) }))} />
      <RankCard title="TOP COLABORADORES · FATURAMENTO" testid="pc-rank-collab-value"
        rows={data.top_collaborators_value.map((r) => ({ label: r.name, value: fmtBRL(r.finalized_value) }))} />
      <RankCard title="MAIS RÁPIDOS · MOV/HORA" testid="pc-rank-fastest"
        rows={data.fastest_collaborators.map((r) => ({ label: r.name, value: `${r.moves_per_hour}/h` }))} />
      <RankCard title="TOP SKUs · QTD VENDIDA" testid="pc-rank-skus"
        rows={data.top_skus.map((r) => ({ label: r.sku, value: fmtInt(r.sold_qty) }))} />
      <RankCard title="TOP CLIENTES · VALOR" testid="pc-rank-customers"
        rows={data.top_customers.map((r) => ({ label: r.name, value: fmtBRL(r.value) }))} />
      <RankCard title="TOP POSTOS · MOVIMENTOS" testid="pc-rank-stations"
        rows={data.top_stations.map((r) => ({ label: r.label, value: fmtInt(r.movements) }))} />
      <RankCard title="TOP SETORES · PEÇAS" testid="pc-rank-sectors"
        rows={data.top_sectors.map((r) => ({ label: `${r.name} (${r.collaborators} colab.)`, value: fmtInt(r.pieces) }))} />
      <RankCard title="TOP DIAS · PEÇAS PRODUZIDAS" testid="pc-rank-days"
        rows={data.top_days.map((r) => ({ label: r.d.split("-").reverse().join("/"), value: `${fmtInt(r.pieces)} (${r.orders} ped.)` }))} />
    </div>
  );
}
